import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useAuth } from '../../../auth/AuthProvider';

const CalendarHeader = ({
  currentDate,
  view,
  onViewChange,
  onNavigate,
  onTodayClick,
  onCreateAppointment
}) => {
  const { t, i18n } = useTranslation();
  const { permissions } = useAuth();
  const isPureEmployee = permissions?.isPureEmployee;

  const formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: view === 'day' ? 'long' : undefined
    };
    return date?.toLocaleDateString(i18n.language || 'ro', options);
  };

  const viewOptions = [
    { value: 'day', label: t('calendar.day'), icon: 'Calendar' },
    { value: 'week', label: t('calendar.week'), icon: 'CalendarDays' },
    { value: 'month', label: t('calendar.month'), icon: 'CalendarRange' }
  ];

  const headerLabel = isPureEmployee ? t('calendar.myAppointments') : t('calendar.title');

  return (
    <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 p-6 bg-surface border-b border-border">
      {/* Left Section - Date Navigation + Titlu în funcție de rol */}
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="icon"
            onClick={() => onNavigate('prev')}
            className="w-10 h-10"
          >
            <Icon name="ChevronLeft" size={18} />
          </Button>

          <Button
            variant="outline"
            size="icon"
            onClick={() => onNavigate('next')}
            className="w-10 h-10"
          >
            <Icon name="ChevronRight" size={18} />
          </Button>

          <Button
            variant="ghost"
            onClick={onTodayClick}
            className="px-4 py-2 text-sm font-medium"
          >
            {t('calendar.todayBtn')}
          </Button>
        </div>

        <div className="flex flex-col">
          <span className="text-xs font-medium text-muted-foreground">
            {headerLabel}
          </span>
          <span className="text-xl font-semibold text-foreground">
            {formatDate(currentDate)}
          </span>
        </div>
      </div>

      {/* Right Section - View Controls and Actions */}
      <div className="flex items-center space-x-4">
        {/* View Toggle */}
        <div className="flex items-center bg-muted rounded-lg p-1">
          {viewOptions?.map((option) => (
            <Button
              key={option?.value}
              variant={view === option?.value ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewChange(option?.value)}
              className="px-3 py-2 text-sm font-medium"
            >
              <Icon name={option?.icon} size={16} className="mr-2" />
              <span className="hidden sm:inline">{option?.label}</span>
            </Button>
          ))}
        </div>

        {/* Create Appointment Button */}
        <Button
          type="button"
          variant="default"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onCreateAppointment();
          }}
          className="px-4 py-2"
        >
          <Icon name="Plus" size={16} className="mr-2" />
          <span className="hidden sm:inline">{t('calendar.newAppointment')}</span>
          <span className="sm:hidden">{t('calendar.newShort')}</span>
        </Button>
      </div>
    </div>
  );
};

export default CalendarHeader;
